import SplitIOContext from "context/splitio-context";
import UserContext from "context/user-context";
import useSplitIO from "hooks/use-splitio";
import { ActiveUser } from "hooks/use-user";
import { ReactNode, useEffect, useState } from "react";

interface ApplicationFormProviderProps {
  children: ReactNode;
  user: ActiveUser;
}

const ApplicationFormProvider = ({
  children,
  user,
}: ApplicationFormProviderProps) => {
  const splits = useSplitIO(null, user.getUserId());

  const [splitsReady, setSplitsReady] = useState(false);
  useEffect(() => {
    splits.isReady?.then(() => setSplitsReady(true));
  });
  return (
    <UserContext.Provider value={user}>
      <SplitIOContext.Provider value={splits}>
        {splitsReady ? children : null}
      </SplitIOContext.Provider>
    </UserContext.Provider>
  );
};

export default ApplicationFormProvider;
